import PageSize from './PageSize';

export default PageSize;
